<template>
  <div class="point-history-template" theme>
    <div id="point-history-content" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      path: 'user',
      parts: [
        {
          elem: '#point-history-content',
          htmlFile: 'point-history'
        }
      ]
    }
  }
}
</script>
